import i18next from 'i18next';

export const format: i18next.FormatFunction = (value, format, lng) => {
  try {
    if (format === 'date' && value instanceof Date && lng) {
      const opts = { year: 'numeric', month: '2-digit', day: '2-digit' };
      return new Intl.DateTimeFormat(lng, opts).format(value);
    }
  } catch {}

  return String(value);
};
